export const post = (url = ``, data = {}) => {
	return fetch(url, {
		method: "POST",
		mode: "cors",
		cache: "no-cache",
		credentials: "same-origin",
		headers: {
			"Content-Type": "application/json",
		},
		redirect: "follow",
		referrer: "no-referrer",
		body: JSON.stringify(data),
	}).then((response) => response.json());
};

export const get = (url = ``) => {
	return fetch(url, {
		method: "GET",
		mode: "cors",
		cache: "no-cache",
		credentials: "same-origin",
		headers: {
			"Content-Type": "application/json",
		},
		redirect: "follow",
		referrer: "no-referrer",
	}).then((response) => response.json());
};

export const switchInsurance = (cartId, cartItemId, insuranceId) => {
	if (insuranceId) {
		return post("/cart/api/setInsurance", { cartItemId, insuranceId });
	} else {
		return post("/cart/api/removeInsurance", { cartId, cartItemId });
	}
};

export const setConfigService = (
	cartItemId,
	serviceProductId,
	optionProductIds,
) => {
	if (serviceProductId) {
		return post("/cart/api/setConfigService", {
			cartItemId,
			serviceProductId,
			optionProductIds,
		});
	} else {
		return post("/cart/api/removeConfigService", { cartItemId });
	}
};

export const removeConfigService = (
	cartItemId,
	serviceProductId,
	optionProductIds,
) =>
	post("/cart/api/removeConfigService", {
		cartItemId,
		serviceProductId,
		optionProductIds,
	});

export const getSubscriptionTermsData = ({
	productId,
	selectedConfigServiceIds,
}) =>
	post("/addtocartpopup/getFlexCalculationData", {
		productId: `${productId}`,
		selectedConfigServiceIds,
	});

export const getPopupData = ({ productId, renewalPeriod }) =>
	post("/addtocartpopup/getPopupData", {
		productId: `${productId}`,
		renewalPeriod,
	});

export const getSubscriptionData = ({
	productId,
	price,
	taxRate,
	isConfigBundle,
	subGroup,
	renewalPeriod,
	isConfigServiceIncluded,
	configServices
}) =>
	post("/addtocartpopup/getSubscriptionData", {
		productId,
		price: price,
		taxRate,
		isConfigBundle,
		subGroup,
		renewalPeriod,
		isConfigServiceIncluded,
		configServices
	});

export const setPopupEnabled = (isEnabled) =>
	post("/addtocartpopup/enable", { isEnabled });

export const getStrings = () => get("/addtocartpopup/getStrings");
